import { useQuery } from "@tanstack/react-query";
import { getBudgetRisk } from "../api";

// Budget risk cards data (GET /api/v1/budgets/{id}/risk). Gated on a saved
// budget id — create mode has no id yet, so the fetch stays disabled until
// the budget exists (mirrors budgetQuery/ownersQuery/scopeQuery's
// `enabled: isEditMode` pattern in BudgetCockpitPage).
export function useBudgetRisk(budgetId) {
  return useQuery(["budgetRisk", budgetId], () => getBudgetRisk(budgetId), {
    enabled: budgetId != null && budgetId !== "",
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
